import { SyncUnAuthorizedControllerService } from 'api';
import { roomInfoStore } from 'state/store';

interface UseRecordingResult {
    syncTimeWithServer(): Promise<void>;
}

export const useSyncTime = (): UseRecordingResult => {
    const fetchServerTime = async () => {
        const { payload } = await SyncUnAuthorizedControllerService.sync();

        if (payload) {
            return payload.serverTime;
        }

        return undefined;
    };

    const syncTimeWithServer = async () => {
        const serverTime = await fetchServerTime();
        const delta = serverTime ? Date.now() - serverTime : 0;
        roomInfoStore.setDeltaWithServerTime(delta);
    };

    return {
        syncTimeWithServer,
    };
};
